import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const SportFormFormStack = styled.form.attrs({ className: "space-y-5" })``;

export const SportFormGridLayout = styled.div.attrs({ className: "grid gap-4" })``;

export const SportFormContentStack = styled.div.attrs({ className: "space-y-2" })``;

export const SportFormFieldLabel = styled.label.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const SportFormFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const SportFormGridLayoutSecondary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const SportFormFieldSelect = styled.select.attrs({ className: "brand-input" })``;

export const SportFormContentStackSecondary = styled.div.attrs({ className: "space-y-3" })``;

export const SportFormHeaderRow = styled.div.attrs({
  className: "flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between",
})``;

export const SportFormMetaText = styled.p.attrs({
  className: "mt-1 text-xs text-[var(--brand-muted)]",
})``;

export const SportFormFieldLabelSecondary = styled.label.attrs({
  className:
    "brand-button-secondary inline-flex w-full cursor-pointer items-center justify-center gap-2 sm:w-auto",
})``;

export const SportFormFieldInputSecondary = styled.input.attrs({ className: "hidden" })``;

export const SportFormContentStackTertiary = styled.div.attrs({
  className: "brand-panel-muted space-y-4",
})``;

export const SportFormPreviewImage = styled(FallbackImage).attrs({
  className: "mx-auto h-24 w-24 rounded-[20px] sm:mx-0 sm:h-28 sm:w-28 sm:rounded-[22px]",
})``;

export const SportFormEmptyStatePanel = styled.div.attrs({
  className:
    "mx-auto flex h-24 w-24 items-center justify-center rounded-[20px] border border-dashed border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] text-center text-sm text-[var(--brand-muted)] sm:mx-0 sm:h-28 sm:w-28 sm:rounded-[22px]",
})``;

export const SportFormInlineText = styled.span.attrs({
  className: "inline-flex items-center gap-2",
})``;

export const SportFormActionRow = styled.div.attrs({
  className:
    "flex flex-col-reverse gap-3 border-t border-[var(--brand-border)] pt-5 sm:flex-row sm:justify-end [&>*]:w-full sm:[&>*]:w-auto",
})``;

export const SportFormSecondaryButton = styled.button.attrs({
  className: "brand-button-secondary w-full sm:w-auto",
})``;

export const SportFormPrimaryButton = styled.button.attrs({
  className: "brand-button w-full sm:w-auto",
})``;

